import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { GetCompaniesByUserId } from "./getCompanies";

export class ChangeCompanyDBTypeCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) {}

  async run(company_id: number, connector_type: String): Promise<void> {
    let args = {
      company_id:company_id,
      companydb_type:connector_type
    }
    let res = await this.dispatcher.dispatch('change_companydb_type', args)
    if (res.output && res.output['status'] && res.output['message']) {
      this.frontend.setSnackbar(res.output.status, res.output.message);
      if (res && res.output['status'] == 'success') {
        window.location.reload();
      }
    }
  }
}